import { useMutation, useQueryClient } from 'react-query';
import { useActionLogger } from '@/shared/hooks/action-logger';
import { updateEventChainLink } from '../index';
export const useUpdateEventChainLink = (callback) => {
    const queryClient = useQueryClient();
    const { setAction } = useActionLogger();
    return useMutation(updateEventChainLink, {
        onSuccess: () => {
            setAction({
                type: 'success',
                message: 'Updating the event chain link was successful',
            });
            if (callback && typeof callback === 'function') {
                callback();
            }
            // Возвращаем промис - мутация остаётся isLoading до перезагрузки списка,
            // иначе чекбокс в таблице на мгновение откатывается к старому значению.
            return queryClient.invalidateQueries('EventChainLinks');
        },
        onError: (error) => {
            setAction({
                type: 'error',
                message: error.toString(),
            });
        },
    });
};
